<template>
    <div>
        <v-data-table
            ref="doctorsTable"
            dense
            disable-sort
            :headers="headers"
            :items="items"
            :items-per-page="10"
            @pagination="getPagination"
            :loading="loading"
        >
            <template
                v-slot:body="{ items }"
            >
                <drop
                    v-for="(item, index) in items"
                    :key="index"
                    tag="tbody"
                    @drop="draggedDropCase($event, item)"
                    :class="{'selected primary lighten-3': hoveredRowDoctorId == item.doctor_id}"
                    @dragenter="draggedCase($event, item.doctor_id)"
                    @dragleave="onDragLeave"
                    @dragover="draggedCase($event, item.doctor_id)"
                >
                    <tr
                        :id="'doctor-row-'+item.id"
                        style="cursor:pointer"
                        @click="showDoctorDetails(item)"
                    >
                        <td>
                            {{ item.name }}
                        </td>
                        <td v-if="canAssignToDoctor">
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                    @click.stop="assignCaseToDoctor(item)"
                                    v-on="on"
                                    v-bind="attrs"
                                    color="primary"
                                >
                                    mdi-plus-circle
                                </v-icon>
                                </template>
                                <span>Assign</span>
                            </v-tooltip>
                        </td>
                        <td>
                            {{ item.specialization }}
                        </td>
                        <td class="text-lowercase">
                            {{ item.status }}
                        </td>
                        <td>
                            {{ item.availability }}
                        </td>
                    </tr>
                </drop>
            </template>
        </v-data-table>
    </div>
</template>

<script>
    import DASHBOARD_STORE from "../store/dashboard.module";
    import API from "@/api";
    const User = API.get("User");
    export default {
        props: {
            filters: {
                type: Object,
                default: () => {
                    return {
                        name: null,
                        specializations: [],
                        status: []
                    };
                }
            },
            canAssignToDoctor: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {
                headers: [
                    { 
                        text: "Doctor",
                        value: "name",
                        class:"primary--text",
                        filter: value => {
                            if (!this.filters.name) { return true; }
                            else { return value.toLowerCase().includes(this.filters.name.toLowerCase()); }
                        }
                    },
                    { 
                        text: "Specialization",
                        value: "specialization",
                        class:"primary--text",
                        filter: value => {
                            if (!this.filters.specializations.length) { return true; }
                            else { return this.filters.specializations.includes(value); }
                        }
                    },
                    { 
                        text: "Status",
                        value: "status",
                        class:"primary--text",
                        filter: value => {
                            if (!this.filters.status.length) { return true; }
                            else { return this.filters.status.includes(value); }
                        }
                    },
                    { 
                        text: "Availability",
                        value: "availability",
                        class:"primary--text"
                    }
                ],
                items: [],
                hoveredRowDoctorId: null,
                loading: false
            }
        },
        watch: {
            filters: function() {
                this.hoveredRowDoctorId = null;
            },
        },

        methods: {
            getPagination(pagination) {
                this.$emit("getResultCount", pagination.itemsLength);
            },

            getDoctors() {
                this.loading = true;

                let params = {
                    doctors_only: true,
                    per_page: 999999 //temporary to get all
                }

                User.getUserDoctors({ params })
                    .then(response => {
                        let data  = response.data.data;

                        let doctors = data.filter(item => item.doctor)
                            .map(item => {
                                let specialization = item.doctor?.specialization?.specialization?.specialization || null;

                                let name = item.doctor.fullname
                                    ? item.doctor.fullname
                                    : item.doctor.first_name || item.doctor.last_name
                                        ? `${item.doctor.first_name} ${item.doctor.last_name}`
                                        : item.doctor.email

                                return {
                                    doctor_id: item.doctor.id,
                                    name,
                                    specialization: specialization,
                                    status: item.doctor.status || "Offline",
                                    availability: "10:00 - 12:00 NN",
                                    calls: [],
                                    full_data: item
                                };
                            });

                        this.items = doctors;
                    })
                    .catch(() => {
                        this.items = [];
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },

            draggedDropCase(event, doctor) {
                DASHBOARD_STORE.dispatch("assignCaseToDoctor", {
                    case: event,
                    doctor
                });

                this.hoveredRowDoctorId = null;
            },

            draggedCase(event, doctorId) {
                this.hoveredRowDoctorId = doctorId;
                return;
            },

            onDragLeave() {
                // console.log({ event, doctorId }, "onDragLeave")
                this.hoveredRowDoctorId = null;
                return;
            },

            showDoctorDetails(item) {
                this.$emit("showDoctorDetails", item);
            },

            setHeaders() {
                if (!this.canAssignToDoctor) return;
                let additionalHeader = { 
                    text: "Assign",
                    value: "assign",
                    class:"primary--text"
                };

                let nameHeaderIndex = 1

                this.headers.splice(nameHeaderIndex, 0, additionalHeader);
            },
            
            assignCaseToDoctor(item) {
                let selectedCase = DASHBOARD_STORE.getters.selectedCase;

                DASHBOARD_STORE.dispatch("assignCaseToDoctor", {
                    case: selectedCase,
                    doctor: item
                });
            }
        },
        mounted() {
            this.setHeaders();
            this.getDoctors();
        }
    }
</script>